// extracted by mini-css-extract-plugin
export default {"AppImg":"AppImg_AppImg__umtnK","AppImg__img":"AppImg_AppImg__img__Ztbja","size_m":"AppImg_size_m__CtWJT","size_l":"AppImg_size_l__Z6q4W"};